module.exports = __webpack_public_path__ + "static/media/logo.c64b29a2.png";